import * as React from 'react';
import { createRoot } from 'react-dom/client';
import './assets/css/fonts.css';
import './index.css';
import App from './App';
import './config/index'

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
